import { useEffect, useState } from "react";
import { apiGet } from "../../../components/Common/Axios";
import {
  ClassNames,
  LectureType,
  DisplayYears,
  RegionNames,
  SchoolType,
} from "../../../lib/types";
import toast from "react-hot-toast";
import styled from "styled-components";
import ProgressChart from "../../../components/Common/Chart/ProgressChart";
import MyPieChart from "../../../components/Common/Chart/MyPieChart";
import StackBarChart from "../../../components/Common/Chart/StackBarChart";
import { Link } from "react-router-dom";
import { RootState, useAppDispatch, useAppSelector } from "store";
import { setMenuIndex } from "store/userSlice";
import { cn } from "lib/utils";
import { setDashboardYear } from "store/mainSlice";
import { Goal } from "lib/models";
import { set } from "date-fns";
import ProgressChartOnly from "components/Common/Chart/ProgressChartOnly";

class SalesResult {
  sidoId: number = 0;
  gugunId: number = 0;
  classType: number = 0;
  schoolType: number = 0;
  schoolId: number = 0;
  schoolSalesId: number = 0;
  classCount: number = 0;
  revenue: number = 0;
  cost: number = 0;
  profit: number = 0;
  year: number = 0;
}

class GoalsResult {
  sidoId: number = 0;
  gugunId: number = 0;
  gugunName: string = "";
  classType: number = 0;
  schoolType: number = 0;
  classCount: number = 0;
  revenue: number = 0;
  profit: number = 0;
}

class GugunResult {
  sidoId: number = 0;
  gugunId: number = 0;
  gugunName: string = "";
  salesCount: number = 0;
  goalCount: number = 0;
}

interface RegionResult {
  name: string;
  value: number;
  //remain: number;
}

const sidos = [
  1, // 서울
  10, // 경기
  5, // 인천
];

function SchoolDashboard() {
  const [salesResults, setSalesResults] = useState<SalesResult[]>();
  const [goalsResults, setGoalsResults] = useState<GoalsResult[]>();
  const [vatInvoiceResult, setVatInvoiceResult] = useState<{
    revenueInputIncompletes: { year: number; cnt: number }[];
    vatInvoiceNotRequestes: { year: number; cnt: number }[];
    isssuedIncompletes: { year: number; cnt: number }[];
    depositIncompletes: { year: number; cnt: number }[];
    vatInvoiceSupplyTotal: number;
    vatInvoiceDepositTotal: number;
  }>({
    revenueInputIncompletes: [],
    vatInvoiceNotRequestes: [],
    isssuedIncompletes: [],
    depositIncompletes: [],
    vatInvoiceSupplyTotal: 0, // 세금계산서 공급가총액
    vatInvoiceDepositTotal: 0, // 세금계산서 입금된 공급가 총액
  });
  const [goals, setGoals] = useState<Goal[]>([]);

  const dispatch = useAppDispatch();
  const dashboardYear = useAppSelector(
    (state: RootState) => state.main.dashboardYear
  );

  // 매출현황
  // currentXXXX는 영업때마다 매출과 수익을 입력하지 않을때 매출을 단가표에 맞추어 계산하던 방식임.
  // 이제는 영업때마다 매출과 수익을 입력하므로 필요없음.
  // const [currentRevenue, setCurrentRevenue] = useState<number>(0);
  // const [currentProfit, setCurrentProfit] = useState<number>(0);
  const [goalRevenue, setGoalRevenue] = useState<number>(0);
  const [goalProfit, setGoalProfit] = useState<number>(0);
  const [currentClassCnt, setCurrentClassCnt] = useState<number>(0);
  const [goalClassCnt, setGoalClassCnt] = useState<number>(0);
  const [vatInvoiceSupplyTotal, setVatInvoiceSupplyTotal] = useState<number>(0);
  const [revenue, setRevenue] = useState<number>(0);
  const [profit, setProfit] = useState<number>(0);
  const [, setCost] = useState<number>(0);
  const [count, setCount] = useState<number>(0);
  const [grossProfitMargin, setGrossProfitMargin] = useState<number>(0);

  const calcTotal = (
    sales: SalesResult[],
    // goals: GoalsResult[],
    goals: Goal[]
  ) => {
    //--------------------------
    // 매출 현황
    //--------------------------
    // 현재 매출
    // const _currentRevenue = sales.reduce((acc, cur) => acc + cur.revenue, 0);
    // setCurrentRevenue(_currentRevenue);

    // 현재 수익
    // const _currentProfit = sales.reduce((acc, cur) => acc + cur.profit, 0);
    // setCurrentProfit(_currentProfit);

    // 현재 학급 수
    const _currentClassCnt = sales.reduce(
      (acc, cur) => acc + cur.classCount,
      0
    );
    setCurrentClassCnt(_currentClassCnt);

    // 목표 매출
    // const _goalRevenue = goals.reduce((acc, cur) => acc + cur.revenue, 0);
    // setGoalRevenue(_goalRevenue);
    // // 목표 수익
    // const _goalProfit = goals.reduce((acc, cur) => acc + cur.profit, 0);
    // setGoalProfit(_goalProfit);
    // // 목표 학급 수
    // const _goalClassCnt = goals.reduce((acc, cur) => acc + cur.classCount, 0);
    // setGoalClassCnt(_goalClassCnt);
    const goal = goals.find((g) => g.year === dashboardYear);

    setGoalRevenue(goal?.revenue ?? 0);
    setGoalProfit(goal?.profit ?? 0);
    setGoalClassCnt(goal?.count ?? 0);

    const r = sales.reduce(
      (acc: number, cur: SalesResult) => acc + cur.revenue,
      0
    );
    setRevenue(r);

    setCost(sales.reduce((acc: number, cur: SalesResult) => acc + cur.cost, 0));

    const p = sales.reduce(
      (acc: number, cur: SalesResult) => acc + cur.profit,
      0
    );
    setProfit(p);

    setGrossProfitMargin((p / r) * 100);
  };

  //--------------------------
  // 초중 비율
  //--------------------------
  const [curSalesCntE, setCurSalesCntE] = useState<number>(0);
  const [curSalesCntM, setCurSalesCntM] = useState<number>(0);
  const [curSalesCntH, setCurSalesCntH] = useState<number>(0);
  const [curSalesCntU, setCurSalesCntU] = useState<number>(0);
  const [curSalesCntO, setCurSalesCntO] = useState<number>(0);
  // const [goalSalesCntE, setGoalSalesCntE] = useState<number>(0);
  // const [goalSalesCntM, setGoalSalesCntM] = useState<number>(0);
  // const [goalSalesCntH, setGoalSalesCntH] = useState<number>(0);
  // const [goalSalesCntU, setGoalSalesCntU] = useState<number>(0);
  // const [goalSalesCntO, setGoalSalesCntO] = useState<number>(0);

  const calcScholRate = (sales: SalesResult[], goals: GoalsResult[]) => {
    const _curClassCountE = sales.reduce(
      (acc, cur) =>
        acc + (cur.schoolType === SchoolType.ELEMENTARY ? cur.classCount : 0),
      0
    );
    setCurSalesCntE(_curClassCountE);

    const _curClassCountM = sales.reduce(
      (acc, cur) =>
        acc + (cur.schoolType === SchoolType.MIDDLE ? cur.classCount : 0),
      0
    );
    setCurSalesCntM(_curClassCountM);

    const _curClassCountH = sales.reduce(
      (acc, cur) =>
        acc + (cur.schoolType === SchoolType.HIGH ? cur.classCount : 0),
      0
    );
    setCurSalesCntH(_curClassCountH);

    const _curClassCountU = sales.reduce(
      (acc, cur) =>
        acc + (cur.schoolType === SchoolType.UNIVERSITY ? cur.classCount : 0),
      0
    );
    setCurSalesCntU(_curClassCountU);

    const _curClassCountO = sales.reduce(
      (acc, cur) =>
        acc + (cur.schoolType === SchoolType.ORGANIZATION ? cur.classCount : 0),
      0
    );
    setCurSalesCntO(_curClassCountO);

    // const _goalClassCountE = goals.reduce(
    //   (acc, cur) =>
    //     acc + (cur.schoolType === SchoolType.ELEMENTARY ? cur.classCount : 0),
    //   0
    // );
    // setGoalSalesCntE(_goalClassCountE);

    // const _goalClassCountM = goals.reduce(
    //   (acc, cur) =>
    //     acc + (cur.schoolType === SchoolType.MIDDLE ? cur.classCount : 0),
    //   0
    // );
    // setGoalSalesCntM(_goalClassCountM);

    // const _goalClassCountH = goals.reduce(
    //   (acc, cur) =>
    //     acc + (cur.schoolType === SchoolType.HIGH ? cur.classCount : 0),
    //   0
    // );
    // setGoalSalesCntH(_goalClassCountH);

    // const _goalClassCountU = goals.reduce(
    //   (acc, cur) =>
    //     acc + (cur.schoolType === SchoolType.UNIVERSITY ? cur.classCount : 0),
    //   0
    // );
    // setGoalSalesCntU(_goalClassCountU);

    // const _goalClassCountO = goals.reduce(
    //   (acc, cur) =>
    //     acc + (cur.schoolType === SchoolType.ORGANIZATION ? cur.classCount : 0),
    //   0
    // );
    // setGoalSalesCntO(_goalClassCountO);
  };

  //--------------------------
  // 과목별 비율
  //--------------------------
  // [수업추가시]
  const [curClassCnts, setCurClassCnts] = useState<number[]>([0, 0, 0, 0, 0]);
  // const [goalClassCnts, setGoalClassCnts] = useState<number[]>([0, 0, 0, 0, 0]);

  const calcClassRate = (sales: SalesResult[], goals: GoalsResult[]) => {
    const _curClassCnts = [0, 0, 0, 0, 0];
    // const _goalClassCnts = [0, 0, 0, 0, 0];

    sales.forEach((sales) => {
      switch (sales.classType) {
        case LectureType.startup:
          _curClassCnts[0] += sales.classCount;
          break;
        case LectureType.makejob:
          _curClassCnts[1] += sales.classCount;
          break;
        case LectureType.ai:
          _curClassCnts[2] += sales.classCount;
          break;
        case LectureType.economy:
          _curClassCnts[3] += sales.classCount;
          break;
        case LectureType.university:
          _curClassCnts[4] += sales.classCount;
          break;
        // case ClassType.startup_ai:
        //   _curClassCnts[5] += sales.classCount;
        //   break;
      }
    });

    // goals.forEach((goals) => {
    //   switch (goals.classType) {
    //     case ClassType.startup:
    //       _goalClassCnts[0] += goals.classCount;
    //       break;
    //     case ClassType.makejob:
    //       _goalClassCnts[1] += goals.classCount;
    //       break;
    //     case ClassType.ai:
    //       _goalClassCnts[2] += goals.classCount;
    //       break;
    //     case ClassType.economy:
    //       _goalClassCnts[3] += goals.classCount;
    //       break;
    //     case ClassType.university:
    //       _goalClassCnts[4] += goals.classCount;
    //       break;
    //     // case ClassType.startup_ai:
    //     //   _goalClassCnts[5] += goals.classCount;
    //     //   break;
    //   }
    // });

    setCurClassCnts([..._curClassCnts]);
    // setGoalClassCnts([..._goalClassCnts]);
  };

  //--------------------------
  // 지역별 비율
  //--------------------------
  const [curRegionCnts, setCurRegionCnts] = useState<number[]>([0, 0, 0]);
  // const [goalRegionCnts, setGoalRegionCnts] = useState<number[]>([0, 0, 0]);

  const calcRegionRate = (sales: SalesResult[], goals: GoalsResult[]) => {
    const _curRegionCnts = [0, 0, 0];
    // const _goalRegionCnts = [0, 0, 0];

    sales.forEach((sales) => {
      switch (sales.sidoId) {
        case 1:
          _curRegionCnts[0] += sales.classCount;
          break;
        case 10:
          _curRegionCnts[1] += sales.classCount;
          break;
        case 5:
          _curRegionCnts[2] += sales.classCount;
          break;
      }
    });

    // goals.forEach((goals) => {
    //   switch (goals.sidoId) {
    //     case 1:
    //       _goalRegionCnts[0] += goals.classCount;
    //       break;
    //     case 10:
    //       _goalRegionCnts[1] += goals.classCount;
    //       break;
    //     case 5:
    //       _goalRegionCnts[2] += goals.classCount;
    //       break;
    //   }
    // });

    setCurRegionCnts([..._curRegionCnts]);
    // setGoalRegionCnts([..._goalRegionCnts]);
  };

  //--------------------------
  // 지역 구군별 현황
  //--------------------------
  // const [regions1, setRegion1] = useState<GugunResult[]>([]);
  // const [regions5, setRegion5] = useState<GugunResult[]>([]);
  // const [regions10, setRegion10] = useState<GugunResult[]>([]);

  const calcGugunRate = (sales: SalesResult[], goals: GoalsResult[]) => {
    const _region1: GugunResult[] = [];
    const _region10: GugunResult[] = [];
    const _region5: GugunResult[] = [];

    goals.forEach((goal) => {
      if (goal.classCount === 0) {
        return;
      }
      let gugun: GugunResult | undefined = undefined;

      switch (goal.sidoId) {
        case 1:
          gugun = _region1.find((g) => g.gugunId === goal.gugunId);
          break;
        case 10:
          gugun = _region10.find((g) => g.gugunId === goal.gugunId);
          break;
        case 5:
          gugun = _region5.find((g) => g.gugunId === goal.gugunId);
          break;
      }

      if (!gugun) {
        gugun = new GugunResult();
        gugun.sidoId = goal.sidoId;
        gugun.gugunId = goal.gugunId;
        gugun.gugunName = goal.gugunName;
        gugun.goalCount = goal.classCount;
      }

      const salesRegions = sales.filter((s) => s.gugunId === goal.gugunId);
      gugun.salesCount = salesRegions
        ? salesRegions.reduce((acc, cur) => acc + cur.classCount, 0)
        : 0;

      switch (goal.sidoId) {
        case 1:
          _region1.push(gugun);
          break;
        case 10:
          _region10.push(gugun);
          break;
        case 5:
          _region5.push(gugun);
          break;
      }
    });

    // setRegion1([..._region1]);
    // setRegion10([..._region10]);
    // setRegion5([..._region5]);
  };

  //--------------------------
  // 상위 영업 구군
  //--------------------------
  const [gugunSaleTop, setGugunSalesTop] = useState<
    { name: string; value: number }[]
  >([]);

  const calcGugunSalesTop = (sales: SalesResult[], goals: GoalsResult[]) => {
    // 구군 매출상위 5개
    const _gugunSalesTop: { name: string; value: number }[] = [];
    const rest = [];

    const ids = new Set(sales.map((s) => s.gugunId));
    const uniqueGugunIds = Array.from(ids);

    const mergedGugunSales = uniqueGugunIds.map((id) => {
      return {
        name: goals.find((g) => g.gugunId === id)?.gugunName ?? "",
        value: sales
          .filter((s) => s.gugunId === id)
          .reduce((acc, cur) => acc + cur.classCount, 0),
      };
    });

    const sortedGugunSales = mergedGugunSales.sort((a, b) => b.value - a.value);

    if (sortedGugunSales && sortedGugunSales.length <= 5) {
      _gugunSalesTop.push(...sortedGugunSales);
    } else {
      _gugunSalesTop.push(...sortedGugunSales.slice(0, 5));
      rest.push(...sortedGugunSales.slice(5));
    }

    if (rest.length > 0) {
      _gugunSalesTop.push({
        name: "기타",
        value: rest.reduce((acc, cur) => acc + cur.value, 0),
      });
    }
    setGugunSalesTop([..._gugunSalesTop]);
  };

  //--------------------------
  // 지역별 구군 영업
  //--------------------------
  const [regionSales, setRegionSales] = useState<RegionResult[][]>([
    [],
    [],
    [],
  ]);

  const calcRegionSales = (sales: SalesResult[], goals: GoalsResult[]) => {
    const goalsArray = Array.from(new Set(goals.map((g) => g.gugunId))).map(
      (g) => goals.find((goal) => goal.gugunId === g)!
    );

    // 구군
    const filteredGoals = goalsArray.map((goal) => {
      const gugunMaxClassCnt = sales
        .filter((s) => s.sidoId === goal.sidoId)
        .reduce((max, sale) => {
          return sale.classCount > max ? sale.classCount : max;
        }, 0);

      return {
        sidoId: goal.sidoId,
        gugunName: goal.gugunName,
        gugunId: goal.gugunId,
        //목표 학급수
        valueGoal: gugunMaxClassCnt,
        // 판매 학급수
        valueSales: sales
          .filter((s) => s.gugunId === goal.gugunId)
          .reduce((acc, cur) => acc + cur.classCount, 0),
      };
    });

    const _regionSales = sidos.map((sidoId, index) =>
      filteredGoals
        .filter((g) => g.sidoId === sidoId)
        .map((g) => {
          return {
            name: g.gugunName,
            value: g.valueSales,
          };
        })
        .sort((a, b) => {
          const diff = b.value - a.value;
          if (diff !== 0) {
            return b.value - a.value;
          }
          return a.name.localeCompare(b.name);
        })
    );

    setRegionSales(_regionSales);
  };

  //--------------------------
  // 전체 계산
  //--------------------------
  const calc = () => {
    if (!salesResults || !goalsResults) {
      return;
    }
    const filterdSalesResults = salesResults.filter(
      (s) => s.year === dashboardYear
    );
    calcTotal(filterdSalesResults, goals);
    calcScholRate(filterdSalesResults, goalsResults); // 초중고대센 별
    calcClassRate(filterdSalesResults, goalsResults); // 과목별 비율
    calcRegionRate(filterdSalesResults, goalsResults); // 지역별 비율
    calcGugunRate(filterdSalesResults, goalsResults); // 지역 구군별 현황
    calcGugunSalesTop(filterdSalesResults, goalsResults); // 상위 영업 구군
    calcRegionSales(filterdSalesResults, goalsResults); // 지역별 구군 영업
  };

  const loadStatistics = async () => {
    const response = await apiGet("/school/statistics");
    if (response.error) {
      toast.error("통계를 불러오는데 실패했습니다.");
      console.error("loadStatistics", response.error);
      return;
    }
    const statisticsResult = response.data;

    setSalesResults(statisticsResult.salesResults);
    setGoalsResults(statisticsResult.goalsResults);
    //setRevenue(Number(statisticsResult.revenue));
    // setRevenue(
    //   statisticsResult.salesResults
    //     .filter((r: SalesResult) => r.year === dashboardYear)
    //     .reduce((acc: number, cur: SalesResult) => acc + cur.revenue, 0)
    // );
    setProfit(Number(statisticsResult.profit));
    setCost(Number(statisticsResult.cost));
    setCount(Number(statisticsResult.count));
    setVatInvoiceResult(statisticsResult.vatInvoiceResult);
    console.log(
      "statisticsResult.vatInvoiceResult",
      statisticsResult.vatInvoiceResult
    );

    setGoals(statisticsResult.goals);
  };

  useEffect(() => {
    dispatch(setMenuIndex(0));
    loadStatistics();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    calc();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [salesResults, goalsResults, dashboardYear]);

  const handleYearClick = (year: number) => {
    if (dashboardYear === year) {
      return;
    }
    dispatch(setDashboardYear(year));
  };

  return (
    <Container>
      <Header className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div className="min-w-0">
          <h1 className="text-xl font-bold tracking-tight text-gray-900 sm:text-2xl">
            영업 대시보드
          </h1>
          <p className="pt-1 text-sm text-gray-500">
            {dashboardYear}년 수업 매출과 영업 현황을 한눈에 확인합니다.
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          {DisplayYears.sort((a, b) => b - a).map((year) => (
            <div
              key={year}
              className={cn(
                "text-xs rounded-md py-2 px-3 cursor-pointer",
                dashboardYear === year
                  ? "bg-indigo-600 text-white border border-indigo-600 shadow-sm"
                  : "bg-white border border-gray-200 text-gray-600 hover:bg-gray-50"
              )}
              onClick={() => handleYearClick(year)}
            >
              {year}년
            </div>
          ))}
        </div>
      </Header>

      <Status className="grid grid-cols-2 gap-3 xl:grid-cols-4">
        <StatTile
          label="매출입력"
          to="/school/sales-total"
          count={
            vatInvoiceResult.revenueInputIncompletes.find(
              (r) => r.year === dashboardYear
            )?.cnt ?? 0
          }
        />
        <StatTile
          label="세금계산서요청"
          to="/school/tax/issue"
          count={
            vatInvoiceResult.vatInvoiceNotRequestes.find(
              (r) => r.year === dashboardYear
            )?.cnt ?? 0
          }
        />
        <StatTile
          label="세금계산서발급"
          to="/school/tax/apply"
          count={
            vatInvoiceResult.isssuedIncompletes.find(
              (r) => r.year === dashboardYear
            )?.cnt ?? 0
          }
        />
        <StatTile
          label="미입금"
          to="/school/tax/deposit"
          count={
            vatInvoiceResult.depositIncompletes.find(
              (r) => r.year === dashboardYear
            )?.cnt ?? 0
          }
        />
      </Status>
      <LeftTop>
        <div>
          {/* {goalRevenue > 0 && (
            <ProgressChart
              data={[
                { name: "매출 예상", value: currentRevenue, max: goalRevenue },
              ]}
              titleJustify="left"
              titleFontSize="0.8rem"
              titleFontWeight="normal"
              valueFontSize="0.8rem"
              valueFontWeight="normal"
              maxFontSize="0.8rem"
              maxFontWeight="lighter"
              unit="원"
              height={40}
              startColorIndex={0}
            />
          )} */}

          <ProgressChart
            data={[
              { name: "매출 현황", value: revenue, max: goalRevenue, count },
            ]}
            titleJustify="left"
            titleFontSize="0.8rem"
            titleFontWeight="normal"
            valueFontSize="0.8rem"
            valueFontWeight="normal"
            maxFontSize="0.8rem"
            maxFontWeight="lighter"
            unit="원"
            height={40}
            startColorIndex={0}
          />

          {/* <ProgressChart
            data={[
              { name: "수익 예상", value: currentProfit, max: goalProfit },
            ]}
            titleJustify="left"
            titleFontSize="0.8rem"
            titleFontWeight="normal"
            valueFontSize="0.8rem"
            valueFontWeight="normal"
            maxFontSize="0.8rem"
            maxFontWeight="lighter"
            unit="원"
            height={45}
            startColorIndex={1}
          /> */}

          <ProgressChart
            data={[
              { name: "수익 현황", value: profit, max: goalProfit, count },
            ]}
            titleJustify="left"
            titleFontSize="0.8rem"
            titleFontWeight="normal"
            valueFontSize="0.8rem"
            valueFontWeight="normal"
            maxFontSize="0.8rem"
            maxFontWeight="lighter"
            unit="원"
            height={45}
            startColorIndex={1}
          />

          <ProgressChart
            data={[
              { name: "영업 현황", value: currentClassCnt, max: goalClassCnt },
            ]}
            titleJustify="left"
            titleFontSize="0.8rem"
            titleFontWeight="normal"
            valueFontSize="0.8rem"
            valueFontWeight="normal"
            maxFontSize="0.8rem"
            maxFontWeight="lighter"
            unit="학급"
            height={45}
            startColorIndex={2}
          />
          <ProgressChart
            data={[
              {
                name: "매출총액(세금계산서기준)",
                value: vatInvoiceResult.vatInvoiceSupplyTotal,
                max: goalRevenue,
              },
            ]}
            titleJustify="left"
            titleFontSize="0.8rem"
            titleFontWeight="normal"
            valueFontSize="0.8rem"
            valueFontWeight="normal"
            maxFontSize="0.8rem"
            maxFontWeight="lighter"
            unit="원"
            height={45}
            startColorIndex={2}
          />

          <ProgressChart
            data={[
              {
                name: "입금총액(세금계산서기준)",
                value: vatInvoiceResult.vatInvoiceDepositTotal ?? 0,
                max: goalRevenue,
              },
            ]}
            titleJustify="left"
            titleFontSize="0.8rem"
            titleFontWeight="normal"
            valueFontSize="0.8rem"
            valueFontWeight="normal"
            maxFontSize="0.8rem"
            maxFontWeight="lighter"
            unit="원"
            height={45}
            startColorIndex={2}
          />

          <ProgressChart
            data={[
              { name: "매출총이익률", value: grossProfitMargin, max: 100 },
            ]}
            titleJustify="left"
            titleFontSize="0.8rem"
            titleFontWeight="normal"
            valueFontSize="0.8rem"
            valueFontWeight="normal"
            maxFontSize="0.8rem"
            maxFontWeight="lighter"
            unit="%"
            height={45}
            startColorIndex={3}
            isShowDetail={false}
          />

          <ProgressChartOnly
            data={[
              { name: "초등", value: curSalesCntE },
              { name: "중등", value: curSalesCntM },
              { name: "고등", value: curSalesCntH },
              { name: "대학", value: curSalesCntU },
              { name: "센터", value: curSalesCntO },
            ]}
            titleJustify="left"
            titleFontSize="0.8rem"
            titleFontWeight="normal"
            valueFontSize="0.8rem"
            valueFontWeight="normal"
            maxFontSize="0.8rem"
            maxFontWeight="lighter"
            unit="학급"
            height={45}
            startColorIndex={0}
          />

          <ProgressChartOnly
            data={[
              { name: "서울", value: curRegionCnts[0] },
              { name: "경기", value: curRegionCnts[1] },
              { name: "인천", value: curRegionCnts[2] },
            ]}
            titleJustify="left"
            titleFontSize="0.8rem"
            titleFontWeight="normal"
            valueFontSize="0.8rem"
            valueFontWeight="normal"
            maxFontSize="0.8rem"
            maxFontWeight="lighter"
            unit="학급"
            height={45}
            startColorIndex={0}
          />

          <ProgressChartOnly
            data={[
              {
                name: ClassNames[0],
                value: curClassCnts[0],
              },
              {
                name: ClassNames[1],
                value: curClassCnts[1],
              },
              {
                name: ClassNames[2],
                value: curClassCnts[2],
              },
              {
                name: ClassNames[3],
                value: curClassCnts[3],
              },
              {
                name: ClassNames[4],
                value: curClassCnts[4],
              },
            ]}
            titleJustify="left"
            titleFontSize="0.8rem"
            titleFontWeight="normal"
            valueFontSize="0.8rem"
            valueFontWeight="normal"
            maxFontSize="0.8rem"
            maxFontWeight="lighter"
            unit="학급"
            height={45}
            startColorIndex={0}
          />
        </div>
      </LeftTop>
      <RightTop>
        <MyPieChart
          title="초중고 비율"
          values={[
            { name: "초등", value: curSalesCntE },
            { name: "중등", value: curSalesCntM },
            { name: "고등", value: curSalesCntH },
            { name: "센터", value: curSalesCntO },
          ]}
          width={300}
          height={250}
        />
        <MyPieChart
          title="과목 비율"
          values={[
            { name: ClassNames[0], value: curClassCnts[0] },
            { name: ClassNames[1], value: curClassCnts[1] },
            { name: ClassNames[2], value: curClassCnts[2] },
            { name: ClassNames[3], value: curClassCnts[3] },
            { name: ClassNames[4], value: curClassCnts[4] },
            { name: ClassNames[5], value: curClassCnts[5] },
          ]}
          width={300}
          height={250}
        />
        <MyPieChart
          title="지역 비율"
          values={[
            { name: RegionNames[0], value: curRegionCnts[0] },
            { name: RegionNames[1], value: curRegionCnts[1] },
            { name: RegionNames[2], value: curRegionCnts[2] },
          ]}
          width={300}
          height={250}
        />
        <MyPieChart
          title="상위 영업 구군"
          values={gugunSaleTop}
          width={300}
          height={250}
        />
      </RightTop>
      <Bottom>
        {regionSales.map((region, index) => (
          <StackBarChart
            data={regionSales[index]}
            colorIndex={index}
            key={index}
          />
        ))}
      </Bottom>
    </Container>
  );
}

const Container = styled.div`
  padding: 16px 16px 80px;
  display: grid;
  grid-template-areas:
    "header"
    "status"
    "left-top"
    "right-top"
    "bottom";
  grid-template-columns: minmax(0, 1fr);
  grid-gap: 16px;
  box-sizing: border-box;
  width: 100%;

  @media (min-width: 1024px) {
    padding: 20px 32px 80px;
    grid-template-areas:
      "header header"
      "status status"
      "left-top right-top"
      "bottom bottom";
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    grid-gap: 20px;
  }

  @media (min-width: 1536px) {
    grid-template-areas:
      "header header header"
      "status status status"
      "left-top right-top bottom";
    grid-template-columns: minmax(0, 4fr) minmax(0, 4fr) minmax(0, 5fr);
  }
`;

const Header = styled.div`
  grid-area: header;
`;

const Status = styled.div`
  grid-area: status;
`;

const StatTile = ({
  label,
  count,
  to,
}: {
  label: string;
  count: number;
  to: string;
}) => (
  <Link
    to={to}
    className={cn(
      "flex flex-col gap-1 rounded-xl border bg-white px-4 py-3 shadow-sm transition-colors",
      count > 0
        ? "border-rose-200 hover:border-rose-300 hover:bg-rose-50/60"
        : "border-gray-200 hover:bg-gray-50"
    )}
  >
    <div className="text-xs text-gray-500">{label}</div>
    <div
      className={cn(
        "text-2xl font-bold tabular-nums",
        count > 0 ? "text-rose-600" : "text-gray-900"
      )}
    >
      {count}
    </div>
  </Link>
);

const LeftTop = styled.div`
  grid-area: left-top;

  background-color: #ffffff;
  box-sizing: border-box;
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 2px rgb(0 0 0 / 4%);
  padding: 16px 12px;
  min-width: 0;
  overflow-x: auto;

  @media (min-width: 768px) {
    padding: 5% 8%;
  }
`;

const RightTop = styled.div`
  grid-area: right-top;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;

  background-color: #ffffff;
  box-sizing: border-box;
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 2px rgb(0 0 0 / 4%);
  padding: 16px 8px;
  min-width: 0;

  @media (min-width: 768px) {
    padding: 5% 8%;
  }
`;
const Bottom = styled.div`
  grid-area: bottom;

  background-color: #ffffff;
  box-sizing: border-box;
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 2px rgb(0 0 0 / 4%);
  padding: 16px 12px;
  min-width: 0;
  overflow-x: auto;

  @media (min-width: 768px) {
    padding: 5% 8%;
  }
`;

export default SchoolDashboard;
